import moment from 'moment';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import {
  Ticket,
  TicketRecordType,
  TicketStatus,
} from 'src/app/models/ticket/ticket.model';
import { getTicketType } from 'src/app/models/ticket/ticket.util';
import { ChartService } from './chart.service';
import { SingleValueKPI } from '../../types';
import {
  LoadTickets,
  LoadTicketsFail,
  LoadTicketsSuccess,
} from '../../../store';
import { ChartType } from '../../types/chart-type';

const DAYS_LIMIT = 30;

@Injectable()
export class OldOpenSupportCasesChartService extends ChartService<SingleValueKPI> {
  public readonly chart$ = this.chartsDataLoader({
    request: LoadTickets,
    failure: LoadTicketsFail,
    success: LoadTicketsSuccess,
  }).pipe(
    map(({ loading, data }) => {
      const dataValue: number =
        data?.data?.filter(
          (ticket) =>
            this.filterByStatusAndType(ticket) &&
            this.oldAgeFilter(ticket.CreatedDate),
        ).length || 0;

      return {
        ngClass: [dataValue > 0 ? 'text-orange-600' : ''],
        loading,
        data: {
          type: ChartType.SINGLE,
          id: `Open support cases > ${DAYS_LIMIT} days`,
          title: `Open Support Tickets (Over ${DAYS_LIMIT} Days)`,
          value: dataValue,
          linkParams: {
            groupBy: 'Status',
            status: TicketStatus.Open,
            type: TicketRecordType.Support,
            olderThan: DAYS_LIMIT,
          },
          linkEnabled: true,
          hyperlink: '/tickets',
        } satisfies SingleValueKPI,
      };
    }),
  );

  private oldAgeFilter(inputDate: moment.MomentInput) {
    const currentDate = moment();
    const differenceInDays = currentDate.diff(inputDate, 'days');
    return differenceInDays > DAYS_LIMIT;
  }

  private filterByStatusAndType(ticket: Ticket): boolean {
    return (
      getTicketType(ticket).includes(TicketRecordType.Support) &&
      !ticket.IsClosed
    );
  }
}
